import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { axiosTokenApi } from "../../../utils/axios";
import { Button, Input, Select } from "antd";
import {
  SearchOutlined,
  DeleteOutlined,
  UndoOutlined,
  MessageOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import moment from "moment";

const QuestionManage = () => {
  const [flag, setFlag] = useState(true);
  const [deleted, setDeleted] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);

  const [questionId, setQuestionId] = useState("");
  const [nickname, setNickname] = useState("");
  const [content, setContent] = useState("");
  const [status, setStatus] = useState(""); // all, public_answered, public_unanswered, private_answered, private_unanswered
  const [language, setLanguage] = useState("");

  const [searchQuestionId, setSearchQuestionId] = useState(0);
  const [searchNickname, setSearchNickname] = useState("");
  const [searchContent, setSearchContent] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [searchLanguage, setSearchLanguage] = useState("");

  useEffect(() => {
    axiosTokenApi
      .get(process.env.REACT_APP_API + "/questions")
      .then((res) => {
        setQuestions(res.data);
      })
      .catch((err) => {
        console.error("Error fetching questions:", err);
      });
    setFlag(false);
    setDeleted(false);
  }, [flag, deleted]);

  const handleSearch = () => {
    if (questionId || nickname || content || status || language) {
      setSearchQuestionId(questionId);
      setSearchNickname(nickname);
      setSearchContent(content);
      setSearchStatus(status);
      setSearchLanguage(language);
      setSearchClicked(true);
    } else {
      setSearchClicked(false);
    }
  };

  const handleReset = () => {
    setQuestionId("");
    setNickname("");
    setContent("");
    setStatus("");
    setLanguage("");
    setSearchClicked(false);
  };

  const deleteQuestion = (id) => {
    if (window.confirm("この質問を削除してもよろしいですか？")) {
      axiosTokenApi
        .delete(process.env.REACT_APP_API + "/questions/" + id)
        .then((res) => {
          setDeleted(true);
          alert("質問を削除しました。");
        })
        .catch((err) => {
          console.error("Error deleting question:", err);
          alert("削除に失敗しました。");
        });
    }
  };

  const handleCSVExport = () => {
    const filteredData = filterQuestions();

    // CSV header
    const headers = [
      "質問ID",
      "ニックネーム",
      "ユーザーID",
      "言語",
      "質問内容",
      "回答内容テキスト",
      "動画URL",
      "音声URL",
      "状態",
      "質問の投稿日時",
      "更新日時",
      "動画日時",
    ];

    // CSV rows
    const rows = filteredData.map((question) => {
      const status = question.is_visible && !question.answer
        ? "公開（未回答）"
        : question.is_visible && question.answer
        ? "公開（回答済）"
        : !question.is_visible && !question.answer
        ? "非公開（未回答）"
        : "非公開（回答済）";

      let videoUrl = "";
      let audioUrl = "";
      let itemDate = "";

      if (question.answer && question.answer.item) {
        const item = question.answer.item;

        if (item.type === '動画' && item.filename) {
          videoUrl = `https://admin.gassho.info/video/${item.filename}`;
          itemDate = item.updatedAt ? moment(item.updatedAt).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss") : "";
        } else if (item.type === '音声' && item.filename) {
          audioUrl = `https://admin.gassho.info/sound/${item.filename}`;
          itemDate = item.updatedAt ? moment(item.updatedAt).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss") : "";
        }
      }

      return [
        question.id,
        question.nickname,
        question.user_id,
        (question.language || 'ja').toUpperCase(),
        question.content,
        question.answer ? question.answer.content || "" : "",
        videoUrl,
        audioUrl,
        status,
        moment(question.created_at).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
        moment(question.updated_at).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
        itemDate,
      ];
    });

    // Create CSV content
    const csvContent = [
      headers.join(","),
      ...rows.map(row =>
        row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(",")
      )
    ].join("\n");

    // Add BOM for Excel UTF-8 support
    const bom = "\uFEFF";
    const blob = new Blob([bom + csvContent], { type: "text/csv;charset=utf-8;" });

    // Create download link
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const timestamp = moment().format("YYYYMMDD_HHmmss");
    link.setAttribute("href", url);
    link.setAttribute("download", `questions_${timestamp}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const filterQuestions = () => {
    if (!searchClicked) {
      return questions;
    }

    return questions.filter((question) => {
      const matchId = searchQuestionId
        ? question.id == searchQuestionId
        : true;
      const matchNickname =
        searchNickname !== ""
          ? question.nickname.includes(searchNickname)
          : true;
      const matchContent =
        searchContent !== "" ? question.content.includes(searchContent) : true;
      const matchStatus =
        searchStatus !== ""
          ? searchStatus === "public_answered"
            ? question.is_visible === true && question.answer !== null
            : searchStatus === "public_unanswered"
            ? question.is_visible === true && question.answer === null
            : searchStatus === "private_answered"
            ? question.is_visible === false && question.answer !== null
            : question.is_visible === false && question.answer === null
          : true;
      const matchLanguage =
        searchLanguage !== ""
          ? (question.language || 'ja') === searchLanguage
          : true;
      return matchId && matchNickname && matchContent && matchStatus && matchLanguage;
    });
  };

  return (
    <div className="p-10 bg-white shadow-md mx-auto my-3 main">
      <div className="w-full h-10 mb-4">
        <p className="text-2xl text-left mx-10 font-bold">質問管理</p>
      </div>

      {/* Search filters */}
      <div className="w-full mb-4 flex">
        <div className="w-1/2 h-10 px-10 flex">
          <div className="w-1/2 text-center text-sm font-medium py-2">
            質問ID
          </div>
          <Input
            value={questionId}
            onChange={(e) => setQuestionId(e.target.value)}
            type="text"
            className="w-1/2"
          />
        </div>
        <div className="w-1/2 h-10 px-10 flex">
          <div className="w-1/3 text-center text-sm font-medium py-2">
            ニックネーム
          </div>
          <Input
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            type="text"
            className="w-2/3"
          />
        </div>
      </div>

      <div className="w-full mb-4 flex">
        <div className="w-1/2 h-10 px-10 flex">
          <div className="w-1/2 text-center text-sm font-medium py-2">
            質問内容
          </div>
          <Input
            value={content}
            onChange={(e) => setContent(e.target.value)}
            type="text"
            className="w-1/2"
          />
        </div>
        <div className="w-1/2 h-10 px-10 flex">
          <div className="w-1/3 text-center text-sm font-medium py-2">
            状態
          </div>
          <Select
            value={status}
            onChange={(value) => setStatus(value)}
            className="w-2/3"
            placeholder="すべて"
            options={[
              { value: "", label: "すべて" },
              { value: "public_unanswered", label: "公開（未回答）" },
              { value: "public_answered", label: "公開（回答済）" },
              { value: "private_unanswered", label: "非公開（未回答）" },
              { value: "private_answered", label: "非公開（回答済）" },
            ]}
          />
        </div>
      </div>

      <div className="w-full mb-4 flex">
        <div className="w-1/2 h-10 px-10 flex">
          <div className="w-1/2 text-center text-sm font-medium py-2">
            言語
          </div>
          <Select
            value={language}
            onChange={(value) => setLanguage(value)}
            className="w-1/2"
            placeholder="すべて"
            options={[
              { value: "", label: "すべて" },
              { value: "ja", label: "日本語" },
              { value: "en", label: "英語" },
            ]}
          />
        </div>
        <div className="w-1/2 h-10 px-10 flex">
        </div>
      </div>

      <Button onClick={handleSearch} className="w-40 bg-black text-white">
        <div className="flex mx-8">
          <SearchOutlined className="mt-1 mr-2" />
          検 索
        </div>
      </Button>
      <Button onClick={handleReset} className="w-40 bg-black text-white mx-2">
        <div className="flex mx-8">
          <UndoOutlined className="mt-1 mr-2" />
          リセット
        </div>
      </Button>
      <Button
        onClick={handleCSVExport}
        className="w-48 mx-2"
        style={{ backgroundColor: '#16a34a', color: 'white' }}
      >
        <div className="flex mx-4">
          <DownloadOutlined className="mt-1 mr-2" />
          CSVエクスポート
        </div>
      </Button>

      {/* Questions table */}
      <div className="w-full h-2/3 p-5 overflow-y-auto">
        <table className="w-full border-collapse text-center text-sm mt-4 mx-auto shadow-md">
          <thead className="border">
            <tr>
              <th>操作</th>
              <th>質問ID</th>
              <th>ユーザーID</th>
              <th>ニックネーム</th>
              <th>言語</th>
              <th>質問内容</th>
              <th>回答</th>
              <th>状態</th>
              <th>投稿日時</th>
            </tr>
          </thead>
          <tbody className="border bg-gray-100">
            {filterQuestions().map((question, index) => (
              <tr key={index}>
                <td className="w-40 text-blue-500 font-bold underline">
                  <Link
                    className="mx-2 text-green-500"
                    to={"/manage/question/" + question.id}
                  >
                    <MessageOutlined /> 回答
                  </Link>
                  <Link
                    className="mx-2 text-red-500"
                    onClick={() => deleteQuestion(question.id)}
                  >
                    <DeleteOutlined /> 削除
                  </Link>
                </td>
                <td>{question.id}</td>
                <td className="text-left px-2" style={{ maxWidth: '150px', wordWrap: 'break-word' }}>
                  {question.user_id}
                </td>
                <td>{question.nickname}</td>
                <td>{(question.language || 'ja') === 'ja' ? '日本語' : '英語'}</td>
                <td className="text-left px-2" style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {question.content}
                </td>
                <td className="text-left px-2" style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {question.answer ? question.answer.content || "" : ""}
                </td>
                <td>
                  {question.is_visible && !question.answer && (
                    <span className="text-blue-600 font-bold">公開（未回答）</span>
                  )}
                  {question.is_visible && question.answer && (
                    <span className="text-green-600 font-bold">公開（回答済）</span>
                  )}
                  {!question.is_visible && !question.answer && (
                    <span className="text-gray-600 font-bold">非公開（未回答）</span>
                  )}
                  {!question.is_visible && question.answer && (
                    <span className="text-orange-600 font-bold">非公開（回答済）</span>
                  )}
                </td>
                <td style={{ minWidth: '120px' }}>
                  {moment(question.created_at)
                    .tz("Asia/Tokyo")
                    .format("YYYY-MM-DD HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuestionManage;
